// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"2718dd1f","585":"6434ab50"}[chunkId] + ".chunk.js";
};